import Tdg_CompanyListPagingResultModelBase from '../_generated/modelBases/tdg-company-list-paging-result-model-base';

export default class Tdg_CompanyListPagingResultModel extends Tdg_CompanyListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
